import { AllocationMode, CostOrGain } from "../store/useAllocationMatrixStore";

export function getOriginalAllocationRule(
  matrices: any[] | undefined,
  matrixId: string | undefined,
  storedRule: any
) {
  if (!storedRule) return storedRule;
  const matrix = (matrices ?? []).find((item) => item.id === matrixId);
  const rules = Array.isArray(matrix?.rules) ? matrix.rules : [];

  // Older grants may have persisted the evaluator's remaining/adjusted rule.
  // Prefer the immutable rule from the matrix. Priority is the primary key;
  // conditions are the fallback for payloads where priority was not returned.
  const byPriority = rules.find(
    (rule: any) =>
      rule.priority != null &&
      storedRule.priority != null &&
      rule.priority === storedRule.priority
  );
  if (byPriority) return byPriority;

  const sameConditions = (a: any, b: any) =>
    JSON.stringify(a?.conditions ?? {}) === JSON.stringify(b?.conditions ?? {});
  const byConditions = rules.find(
    (rule: any) =>
      sameConditions(rule, storedRule) &&
      rule.allocationMode === storedRule.allocationMode &&
      rule.scope === storedRule.scope
  );
  if (byConditions) return byConditions;

  return storedRule;
}

export function calculateAllocationValue({
  options,
  ratio = 1,
  fmv,
  strikePrice = 0,
  allocationMode,
  costOrGain,
}: {
  options: number;
  ratio?: number;
  fmv: number;
  strikePrice?: number;
  allocationMode?: AllocationMode;
  costOrGain?: CostOrGain | null;
}): number {
  if (allocationMode !== AllocationMode.ABSOLUTE_VALUE) return options;
  const shares = options * (ratio || 1);
  return costOrGain === CostOrGain.GAIN
    ? shares * Math.max(0, fmv - strikePrice)
    : shares * fmv;
}
